var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#1D9BF0",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#3671F4",
    strokeOpacity: 0.16,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9855 22.987C30.0552 23.0566 30.1105 23.1393 30.1483 23.2304C30.186 23.3214 30.2054 23.419 30.2054 23.5176C30.2054 23.6161 30.186 23.7137 30.1483 23.8048C30.1105 23.8958 30.0552 23.9785 29.9855 24.0482L24.7355 29.2982C24.6658 29.3679 24.5831 29.4233 24.492 29.461C24.401 29.4987 24.3034 29.5182 24.2048 29.5182C24.1063 29.5182 24.0087 29.4987 23.9176 29.461C23.8266 29.4233 23.7439 29.3679 23.6742 29.2982L21.4242 27.0482C21.2835 26.9075 21.2044 26.7166 21.2044 26.5176C21.2044 26.3186 21.2835 26.1277 21.4242 25.987C21.5649 25.8462 21.7558 25.7672 21.9548 25.7672C22.1539 25.7672 22.3447 25.8462 22.4855 25.987L24.2048 27.7073L28.9242 22.987C28.9939 22.9172 29.0766 22.8619 29.1676 22.8242C29.2587 22.7864 29.3563 22.767 29.4548 22.767C29.5534 22.767 29.651 22.7864 29.742 22.8242C29.8331 22.8619 29.9158 22.9172 29.9855 22.987ZM35.4548 25.7676C35.4548 27.6959 34.883 29.581 33.8117 31.1844C32.7403 32.7878 31.2176 34.0374 29.436 34.7754C27.6544 35.5134 25.694 35.7064 23.8027 35.3302C21.9114 34.954 20.1741 34.0254 18.8105 32.6619C17.447 31.2983 16.5184 29.561 16.1422 27.6697C15.766 25.7784 15.9591 23.818 16.697 22.0364C17.435 20.2548 18.6846 18.7321 20.288 17.6607C21.8914 16.5894 23.7765 16.0176 25.7048 16.0176C28.2899 16.0203 30.7682 17.0484 32.5961 18.8763C34.424 20.7042 35.4521 23.1826 35.4548 25.7676ZM33.9548 25.7676C33.9548 24.1359 33.471 22.5408 32.5645 21.1841C31.6579 19.8274 30.3695 18.77 28.862 18.1456C27.3545 17.5211 25.6957 17.3578 24.0953 17.6761C22.495 17.9944 21.025 18.7802 19.8712 19.9339C18.7174 21.0877 17.9317 22.5577 17.6134 24.1581C17.295 25.7584 17.4584 27.4172 18.0828 28.9247C18.7073 30.4322 19.7647 31.7207 21.1214 32.6272C22.4781 33.5337 24.0731 34.0176 25.7048 34.0176C27.8921 34.0151 29.9891 33.1451 31.5357 31.5985C33.0824 30.0518 33.9524 27.9549 33.9548 25.7676Z",
    fill: "#3771C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.89195207bae6dc2364a21e35f7e46469.svg";
export { ForwardRef as ReactComponent };